import React from "react";

function SvgIcMapPoi015(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15 21a2 2 0 011.995 1.85L17 23H5a2 2 0 011.85-1.995L7 21h8zm2.547-8.33l9.232 5.329c.608.453.797 1.3.41 1.97a1.5 1.5 0 01-1.907.62l-.003.009-9.232-5.33 1.5-2.598zm-9.494.868l5.195 3.001a1 1 0 01-1 1.732l-5.195-3a1 1 0 111-1.733zm3.907-5.826l4.605 2.66a6.984 6.984 0 01-.909 2.938 6.959 6.959 0 01-1.818 2.06l-.273.197-4.605-2.659a6.947 6.947 0 013-5.196zm1.092-2.833l5.196 3a1 1 0 11-1 1.732l-5.196-3a1 1 0 111-1.732z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi015;
